/*
  File name: custom.js
    Program Description:
    - This file sets all conditions or validations that most text fields use
*/

import { helpers } from 'vuelidate/lib/validators'

export const oneOf = (options) => (val) => options.includes(val)
// eslint-disable-next-line security/detect-unsafe-regex
export const isNameLike = helpers.regex('nameLike', /^[[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ,' ','.']+(([ ][0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ,' '])?[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ,' ']*)*$/)
export const minDate = (date) => helpers.withParams({ type: 'minDate', min: date }, value => !helpers.req(value) || value >= date)
export const maxDate = (date, comparisonName = '') => helpers.withParams({ type: 'maxDate', max: date, comparisonName }, value => !helpers.req(value) || value <= date)
export const isYear = helpers.regex('dateLike', /^[12]\d{3}$/)
// eslint-disable-next-line security/detect-unsafe-regex
export const sameName = (name = '', arr = [], field, id) => (value) => {
  if (arr) {
    const filtered = arr.filter((value) => {
      return value._id !== id
    })
    return !helpers.req(value) || !filtered.some((i) => {
      if (i[`${field}`]) {
        return i[`${field}`].toLowerCase().replace(/\s/g, '') === name.toLowerCase().replace(/\s/g, '')
      }
    })
  }
}
export const fileFormat = (options = {}) => {
  return helpers.withParams(options, files => {
    let bool = true
    if (!files) {
      return true
    }
    if (Array.isArray(files)) {
      files.forEach((file) => {
        const { name } = file
        if (name && !options.format.includes(name.split('.').pop().toLowerCase())) {
          bool = false
        }
      })
    } else {
      const { name } = files
      if (name && !options.format.includes(name.split('.').pop().toLowerCase())) {
        bool = false
      }
    }
    return bool
  })
}

export const fileSize = (options = {}) => {
  return helpers.withParams(options, files => {
    let bool = true
    let totalSize = 0
    if (!files) return true
    if (Array.isArray(files)) {
      files.forEach((file) => {
        const { size } = file
        totalSize = size + totalSize
        if ((size / 1048576) > options.max) {
          bool = false
        }
      })
      if (options.totalMax && (totalSize / 1048576) > options.max) {
        bool = false
      }
    } else {
      const { size } = files
      if ((size / 1048576) > options.max) {
        bool = false
      }
    }

    return bool
  })
}

export const exactLength = (options = {}) => {
  return helpers.withParams(options, value => {
    if (!value) return true
    return value && value.length === options.characters
  })
}

export const rangeLength = (options = {}) => {
  return helpers.withParams(options, value => {
    if (!value) return true
    return value && (value.length >= options.min && value.length <= options.max)
  })
}

export const isMaxValue = (options = {}) => {
  return helpers.withParams(options, value => {
    if (!value) return true
    return value && (options.initialValue <= options.maxValue)
  })
}

export const isZeroAmount = () => {
  return helpers.withParams({}, value => {
    return (value && parseFloat(value) !== parseFloat('0.00'))
  })
}

export const isWhole = helpers.regex('wholeNumber', /^[1-9]\d*$/)
